import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=0c68c1ae"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=0c68c1ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports